export default __webpack_public_path__ + "static/media/MyOrdersIcon.7a34eb0f.svg";